import { 
	Search16,
	LicenseMaintenance16,
} from '@carbon/icons';


export default [
	/* **** */
	{
		path: '/search',
		layout: 'Admin',
		component: 'TenderSearch',
		meta: {
			name: 'Поиск тендеров',
			icon: Search16,
		},
		menu: true,
		permissions: [ 'tender_search' ],
	},
	/* **** */
	{
		path: '/tenders',
		redirect: '/tenders/towork',
		layout: 'Admin',
		meta: {
			name: 'Тендеры',
			icon: LicenseMaintenance16,
		},
		menu: true,
		permissions: [ 'selection_towork_view', 'selection_favorites_view', 'selection_personal_view', 'selection_subscription_view' ],
		children: [
			{
				path: '/towork/:id',
				component: 'TenderTowork',
				meta: {
					name: 'В работу',
					params: {
						category: 'towork',
					},
				},
				menu: false,
				permissions: [ 'selection_towork_view' ],
			},
			{
				path: '/towork',
				component: 'TenderTowork',
				meta: {
					name: 'В работу',
					params: {
						category: 'towork',
					},
				},
				menu: true,
				permissions: [ 'selection_towork_view' ],
			},
			{
				path: '/favorites/:id',
				component: 'TenderFavorites',
				meta: {
					name: 'Избранные',
					params: {
						category: 'favorites',
					},
				},
				menu: false,
				permissions: [ 'selection_favorites_view' ],
			},
			{
				path: '/favorites',
				component: 'TenderFavorites',
				meta: {
					name: 'Избранные',
					params: {
						category: 'favorites',
					},
				},
				menu: true,
				permissions: [ 'selection_favorites_view' ],
			},
			{
				path: '/personal/:id',
				component: 'TenderPersonal',
				meta: {
					name: 'Персональные',
					params: {
						category: 'personal',
					},
				},
				menu: false,
				permissions: [ 'selection_personal_view' ],
			},
			{
				path: '/personal',
				component: 'TenderPersonal',
				meta: {
					name: 'Персональные',
					params: {
						category: 'personal',
					},
				},
				menu: true,
				permissions: [ 'selection_personal_view' ],
			},
			{
				path: '/collections/:id',
				component: 'TenderCollections',
				meta: {
					name: 'Подписки',
					params: {
						category: 'collections',
					},
					binding: 'collections_items',
				},
				menu: false,
				permissions: [ 'selection_subscription_view' ],
			},
			{
				path: '/collections',
				component: 'TenderCollections',
				meta: {
					name: 'Подписки',
					params: {
						category: 'collections',
					},
					binding: 'collections_items',
				},
				menu: true,
				permissions: [ 'selection_subscription_view' ],
			},
			{
				path: '/subscription/:id',
				component: 'TenderSubscription',
				meta: {
					name: 'Рассылка',
					params: {
						category: 'subscription',
					},
				},
				menu: false,
				permissions: [ 'selection_subscription_view' ],
			},
			{
				path: '/subscription',
				component: 'TenderSubscription',
				meta: {
					name: 'Рассылка',
					params: {
						category: 'subscription',
					},
				},
				menu: true,
				permissions: [ 'selection_subscription_view' ],
			},
		],
	},
	/* **** */
];
